import React, { CSSProperties } from "react";
import { GlitterSparkles } from "./GlitterSparkles";
import { SearchForm } from "./SearchForm";
type ShopAllCategoriesProps = {
  onBack: () => void;
  onOpenBuckets: () => void;
  onOpenPens: () => void;
  onOpenRhinestoneCharacters: () => void;
  onOpenRhinestones: () => void;
  onOpenTools: () => void;
  onOpenTumblers: () => void;
  onOpenSatchels: () => void;
  onOpenAllThatSparkles: () => void;
  onSearch: (query: string) => void;
};
type CategoryLink = {
  label: string;
  action?: () => void;
  /** Position of this category's sign on the desktop Shop All artwork (percent of image). Omitted when the sign isn't on it. */
  hotspot?: CSSProperties;
  /** Position of this category's sign on the tall mobile Shop All artwork (percent of image). Omitted when the sign isn't on it. */
  mobileHotspot?: CSSProperties;
};
const shopAllMobileImage = "https://cdn.magicpatterns.com/uploads/jPa25D4oxBCNhErLEiLxXW/Sparkling_Shop_All_Mobile_Menu.png";
const mobileRowTops = ["25.1%", "34.2%", "43.4%", "52.5%", "61.7%", "70.8%", "80.1%", "89.2%"];
function mobileRow(index: number): CSSProperties {
  return {
    left: "7.2%",
    width: "85.6%",
    top: mobileRowTops[index],
    height: "7.9%"
  };
}
const shopAllImage = "https://cdn.magicpatterns.com/uploads/2144De1YHxeSX3dg3Y7m8e/All_that_sparkles.png";
const leftColumn = {
  left: "5.1%",
  width: "43.6%"
};
const rightColumn = {
  left: "51.3%",
  width: "43.6%"
};
const rows = [{
  top: "34.4%",
  height: "12.5%"
}, {
  top: "49.6%",
  height: "12.5%"
}, {
  top: "64.9%",
  height: "12.5%"
}, {
  top: "80.3%",
  height: "12.5%"
}];
export function ShopAllCategories({
  onBack,
  onOpenBuckets,
  onOpenPens,
  onOpenRhinestoneCharacters,
  onOpenRhinestones,
  onOpenTools,
  onOpenTumblers,
  onOpenSatchels,
  onOpenAllThatSparkles,
  onSearch
}: ShopAllCategoriesProps) {
  const categories: CategoryLink[] = [{
    label: "Rhinestones",
    action: onOpenRhinestones,
    hotspot: {
      ...leftColumn,
      ...rows[0]
    },
    mobileHotspot: mobileRow(0)
  }, {
    label: "Tumblers",
    action: onOpenTumblers,
    hotspot: {
      ...rightColumn,
      ...rows[0]
    },
    mobileHotspot: mobileRow(1)
  }, {
    label: "Pens",
    action: onOpenPens,
    hotspot: {
      ...leftColumn,
      ...rows[1]
    },
    mobileHotspot: mobileRow(2)
  }, {
    label: "Rhinestone Tools",
    action: onOpenTools,
    hotspot: {
      ...rightColumn,
      ...rows[1]
    },
    mobileHotspot: mobileRow(3)
  }, {
    label: "Characters",
    action: onOpenRhinestoneCharacters,
    hotspot: {
      ...leftColumn,
      ...rows[2]
    },
    mobileHotspot: mobileRow(4)
  }, {
    label: "Rhinestone Purses and Backpacks",
    action: onOpenSatchels,
    hotspot: {
      ...rightColumn,
      ...rows[2]
    },
    mobileHotspot: mobileRow(5)
  }, {
    label: "Buckets",
    action: onOpenBuckets,
    hotspot: {
      ...leftColumn,
      ...rows[3]
    },
    mobileHotspot: mobileRow(6)
  }, {
    label: "All That Sparkles",
    action: onOpenAllThatSparkles,
    hotspot: {
      ...rightColumn,
      ...rows[3]
    },
    mobileHotspot: mobileRow(7)
  }];
  return <main className="relative min-h-[100dvh] w-full bg-[#10070f] px-4 py-10 text-white sm:px-8 sm:py-14" data-id="element-344" data-mp="1sh3ca1qp3jny">
      <GlitterSparkles count={2400} data-id="element-345" data-mp="9mqlv6ii0xgj" />
      <div className="relative mx-auto max-w-5xl" data-id="element-346" data-mp="9ns0fkyq4230">
        <button type="button" onClick={onBack} className="mb-8 text-sm font-medium text-[#35dceb] underline decoration-transparent underline-offset-4 transition-colors duration-150 ease-out hover:decoration-current focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#35dceb]" data-id="element-347" data-mp="4v8pywvc1n2f">
          Back to home
        </button>

        {/* Desktop: Shop All artwork with invisible links over each sign */}
        <section className="hidden md:block" aria-label="Shop categories" data-id="element-348" data-mp="jkekw8n50r4i">
          <h1 className="sr-only" data-id="element-349" data-mp="jmhjvi69puld">Shop All</h1>
          <nav className="relative w-full overflow-hidden" aria-label="Shop categories" data-id="element-350" data-mp="emd3rt99v1vo">
            <img src={shopAllImage} alt="Shop All — find your sparkle, explore our collections" className="block h-auto w-full" data-id="element-351" data-mp="34b5lbk2hght6" />
            <GlitterSparkles count={900} data-id="element-352" data-mp="2za7smdjuk5df" />
            {categories.map(category => category.action && category.hotspot ? <button key={category.label} type="button" onClick={category.action} style={category.hotspot} aria-label={`Shop ${category.label}`} title={category.label} className="group absolute rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" data-id="element-353" data-mp="vtt4ouss9m9e">
                  <span className="absolute inset-0 rounded-lg border-2 border-transparent transition-colors duration-150 ease-out group-hover:border-white/80" aria-hidden="true" data-id="element-354" data-mp="1es5gkob2xa8o" />
                </button> : null)}
          </nav>
          <div className="mx-auto mt-8 max-w-xl" data-id="element-355" data-mp="3lilmmmpwp47f">
            <SearchForm onSearch={onSearch} data-id="element-356" data-mp="3lhtrfd0818ho" />
          </div>
        </section>

        {/* Mobile: tall Shop All artwork with invisible links over each sign */}
        <section className="md:hidden" aria-label="Shop categories" data-id="element-357" data-mp="3ixxcoqotvl5r">
          <h1 className="sr-only" data-id="element-358" data-mp="3dzvx4fqm23z1">Shop All</h1>
          <nav className="relative w-full overflow-hidden" aria-label="Shop categories" data-id="element-359" data-mp="3dyubxifvs13l">
            <img src={shopAllMobileImage} alt="Shop All — find your sparkle, explore our collections" className="block h-auto w-full" data-id="element-360" data-mp="3rybz5tdj36au" />
            <GlitterSparkles count={600} data-id="element-361" data-mp="3my7hw14sq7jk" />
            {categories.map(category => category.action && category.mobileHotspot ? <button key={category.label} type="button" onClick={category.action} style={category.mobileHotspot} aria-label={`Shop ${category.label}`} className="group absolute rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#35dceb]" data-id="element-362" data-mp="2v9xg3a4u50j9">
                  <span className="absolute inset-0 rounded-md border-2 border-transparent transition-colors duration-150 ease-out group-active:border-white/80" aria-hidden="true" data-id="element-363" data-mp="2bklvuou8gm29" />
                </button> : null)}
          </nav>
          <div className="mt-6" data-id="element-364" data-mp="p7a69ihgr6ja">
            <SearchForm onSearch={onSearch} data-id="element-365" data-mp="p94qsvotowmu" />
          </div>
        </section>
      </div>
    </main>;
}